import { observer } from 'mobx-react-lite';
import React from 'react';
import { toLocalCurrency } from 'src/scripts/utils/currency';
import GatedSaleProductPrice from 'src/scripts/templates/product/components/GatedSaleProductPrice';
import { gatedSaleState } from 'src/scripts/templates/product/components/GatedSaleProductPrice/state';

interface CarouselItemPriceProps {
  price: number;
  compareAtPrice: number | null;
  productType?: string;
}

let CarouselItemPrice = ({ price, compareAtPrice, productType }: CarouselItemPriceProps) => {
  const isOnSale = compareAtPrice != null && compareAtPrice > price;

  const gatedSalePricingEnabled =
    isOnSale &&
    productType !== 'Gift Card' &&
    price > 0 &&
    gatedSaleState.getGatedSaleVisibilityConfig.shouldShowGatedSalePricing;

  if (gatedSalePricingEnabled) {
    return <GatedSaleProductPrice price={price} compareAtPrice={compareAtPrice} />;
  }

  return (
    <span
      className={
        isOnSale
          ? 'product-price product-carousel-price product__price sale__price mr-2'
          : 'product-price product-carousel-price product__price'
      }
      data-currency
    >
      {toLocalCurrency(price)}
      {isOnSale ? (
        <span className="product__price--sale">
          <s>{toLocalCurrency(compareAtPrice)}</s>
        </span>
      ) : null}
    </span>
  );
};
CarouselItemPrice = observer(CarouselItemPrice);

export { CarouselItemPrice };
